<template lang="pug">
    div
        InputNumber(size="small" :value="value" :max="formItem.inputMaxNum" :min="formItem.inputMinNum" @on-change="onChange" v-if="!formItem.needTransferUnit" :active-change="false" :disabled="disabled")
        div(style="display: flex; flex-direction: row" v-else)
            InputNumber(v-model="valueByUnit" :max="inputNumberLimit.max" :min="inputNumberLimit.min" @on-change="onChange" :active-change="false" :disabled="disabled")
            Select(v-model="valueUnit"  @on-change="onUnitChange")
                Option(v-for="option in timeUnitOptionArray" :key="option" :value="option") {{$t(`global.${option}`)}}

</template>
<script>
import { minToUnit, transferValueByUnit, getMinutesByUnit, timeUnitOption, getCacheLimitByUnit } from "@/libs/utils.js";

export default {
    props: ["value", "formItem", "formData"],
    data() {
        return {
            timeUnitOptionArray: [],
            unit: "",
            valueUnit: "",
            valueByUnit: 0,
            inputNumberLimit: {},
        };
    },
    methods: {
        onChange(value) {
            if (this.formItem.needTransferUnit) {
                this.$emit("input", getMinutesByUnit(value, this.valueUnit).toString());
            } else {
                this.$emit("input", value);
            }
            if (typeof this.formItem.watchField == "function") this.formItem.watchField(value, this.formData);
        },
        onUnitChange(value) {
            this.inputNumberLimit = getCacheLimitByUnit(value);
            if (
                this.valueByUnit > getCacheLimitByUnit(value).max ||
                this.valueByUnit < getCacheLimitByUnit(value).min
            ) {
                this.valueByUnit = getCacheLimitByUnit(value).min;
            }
            this.$emit("input", getMinutesByUnit(this.valueByUnit, value).toString());
        },
    },
    computed: {
        disabled() {
            return typeof this.formItem.disabled == "function" ? this.formItem.disabled() : this.formItem.disabled;
        },
    },
    mounted() {
        if (this.formItem.needTransferUnit) {
            let valueNumber = parseInt(this.value);
            this.valueUnit = minToUnit(valueNumber);
            this.valueByUnit = transferValueByUnit(valueNumber, this.valueUnit);
            this.timeUnitOptionArray = Object.keys(timeUnitOption);
            this.inputNumberLimit = getCacheLimitByUnit(this.valueUnit);
            this.$emit("input", getMinutesByUnit(this.valueByUnit, this.valueUnit).toString());
        }
    },
};
</script>



// WEBPACK FOOTER //
// src/components/rcmTableFormItems/InputNumber.vue